import type { Commit } from 'vuex';

/**
 * The one place a CRM write result reaches state, and this module's answer to §8 `autosave-failure`.
 *
 * A failed call rejects — the shell's interceptor has already toasted the server error — so the `catch`
 * is the only failure branch: nothing is returned, and a page with no save button keeps the value
 * visibly unsaved instead of showing one the server never took.
 *
 * `SET_ERROR` always carries an **i18n key**, never raw exception text: the view renders it directly, so
 * a transport failure must not reach it as a message the user cannot read.
 */
export async function commitEntity<T>(
    commit: Commit,
    request: () => Promise<T>,
    errorKey: string,
): Promise<T | null> {
    commit('SET_ERROR', null);
    try {
        return await request();
    } catch {
        commit('SET_ERROR', errorKey);
        return null;
    }
}
